import { lazy, Suspense } from "react";
import { Loading } from "./components/ui/loading";
import { keycloak } from "./utils/lib/keycloak";
import { RoleGate } from "./components/role-gate";
import { ROLE } from "./utils/constant";

const TestMFE = lazy(() => import("abdbackbone/TestMFE"));

// ABD Feeder Dashboard
const AbdFeederDashboard = lazy(() => import("abdbackbone/AbdFeederDashboard"));

// ABD Feeder
const AbdFeederList = lazy(() => import("abdbackbone/AbdFeederList"));

// ABD BB Dashboard
const AbdBbDashboard = lazy(() => import("abdbackbone/AbdBbDashboard"));

// ABD BB List
const AbdBbList = lazy(() => import("abdbackbone/AbdBbList"));

// ABD BB Submission List
const AbdBbSubmissionList = lazy(
  () => import("abdbackbone/AbdBbSubmissionList"),
);
const AbdBbSubmissionListCreate = lazy(
  () => import("abdbackbone/AbdBbSubmissionListCreate"),
);

// ABD FO OLT Dashboard
const AbdFoOltDashboard = lazy(() => import("abdbackbone/AbdFoOltDashboard"));

// ABD FO OLT
const AbdFoOltList = lazy(() => import("abdbackbone/AbdFoOltList"));

// ABD FO OLT SubmissionList
const AbdFoOltSubmissionList = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionList"),
);
const AbdFoOltSubmissionListCreate = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionListCreate"),
);
const AbdFoOltSubmissionListDetail = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionListDetail"),
);
const AbdFoOltSubmissionListKmzAbd = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionListKmzAbd"),
);
const AbdFoOltSubmissionListKmzEvidence = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionListKmzEvidence"),
);
const AbdFoOltSubmissionListAbdFoOltDocument = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionListAbdFoOltDocument"),
);
const AbdFoOltSubmissionListAtp = lazy(
  () => import("abdbackbone/AbdFoOltSubmissionListAtp"),
);

// ABD Feeder SubmissionList
const AbdFeederSubmissionCreate = lazy(
  () => import("abdbackbone/AbdFeederSubmissionCreate"),
);
const AbdFeederSubmissionList = lazy(
  () => import("abdbackbone/AbdFeederSubmissionList"),
);
const AbdFeederSubmissionListDetail = lazy(
  () => import("abdbackbone/AbdFeederSubmissionListDetail"),
);
const AbdFeederSubmissionListDetailBbtar = lazy(
  () => import("abdbackbone/AbdFeederSubmissionListDetailBbtar"),
);
const AbdFeederSubmissionListDetailInformation = lazy(
  () => import("abdbackbone/AbdFeederSubmissionListDetailInformation"),
);
const AbdFeederSubmissionListDetailKmzEvidence = lazy(
  () => import("abdbackbone/AbdFeederSubmissionListDetailKmzEvidence"),
);

// ABD BB Submission List
const AbdBbSubmissionListDetail = lazy(
  () => import("abdbackbone/AbdBbSubmissionListDetail"),
);
const AbdBbSubmissionListKmzAbd = lazy(
  () => import("abdbackbone/AbdBbSubmissionListKmzAbd"),
);
const AbdBbSubmissionListKmzEvidence = lazy(
  () => import("abdbackbone/AbdBbSubmissionListKmzEvidence"),
);
const AbdBbSubmissionListAbdBbDocument = lazy(
  () => import("abdbackbone/AbdBbSubmissionListAbdBbDocument"),
);
const AbdBbSubmissionListAtp = lazy(
  () => import("abdbackbone/AbdBbSubmissionListAtp"),
);

// ABD Feeder Handover List
const AbdFeederHandoverList = lazy(
  () => import("abdbackbone/AbdFeederHandoverList"),
);
const AbdFeederHandoverDetail = lazy(
  () => import("abdbackbone/AbdFeederHandoverDetail"),
);

// ABD BB Handover List
const AbdBbHandoverList = lazy(() => import("abdbackbone/AbdBbHandoverList"));
const AbdBbHandoverDetail = lazy(
  () => import("abdbackbone/AbdBbHandoverDetail"),
);

// ABD FO OLT Handover List
const AbdFoOltHandoverList = lazy(
  () => import("abdbackbone/AbdFoOltHandoverList"),
);
const AbdFoOltHandoverDetail = lazy(
  () => import("abdbackbone/AbdFoOltHandoverDetail"),
);

export const abdBackboneRoutes = [
  {
    path: "test-mfe-abd-backbone",
    element: (
      <Suspense fallback={<Loading />}>
        <TestMFE keycloak={keycloak} />
      </Suspense>
    ),
  },
  {
    path: "abd-backbone",
    children: [
      {
        path: "abd-bb-dashboard",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_RING_APPROVER,
                    ROLE.ABD_RING_VERIFICATOR,
                    ROLE.ABD_RING_PBO,
                    ROLE.ABD_RING_MAINTENANCE,
                    ROLE.ABD_RING_VIEW,
                    ROLE.ABD_RING_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdBbDashboard keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-bb-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_RING_APPROVER,
                    ROLE.ABD_RING_VERIFICATOR,
                    ROLE.ABD_RING_PBO,
                    ROLE.ABD_RING_VIEW,
                    ROLE.ABD_RING_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdBbList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-bb-submission-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_RING_APPROVER,
                    ROLE.ABD_RING_VERIFICATOR,
                    ROLE.ABD_RING_PBO,
                    ROLE.ABD_RING_VIEW,
                    ROLE.ABD_RING_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdBbSubmissionList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: "create",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate roles={[ROLE.VENDOR, ROLE.VENDOR_VIEW]}>
                  <AbdBbSubmissionListCreate keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_RING_APPROVER,
                        ROLE.ABD_RING_VERIFICATOR,
                        ROLE.ABD_RING_PBO,
                        ROLE.ABD_RING_VIEW,
                        ROLE.ABD_RING_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdBbSubmissionListDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "kmz-abd",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_RING_APPROVER,
                        ROLE.ABD_RING_VERIFICATOR,
                        ROLE.ABD_RING_PBO,
                        ROLE.ABD_RING_VIEW,
                        ROLE.ABD_RING_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdBbSubmissionListKmzAbd keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "kmz-evidence",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_RING_APPROVER,
                        ROLE.ABD_RING_VERIFICATOR,
                        ROLE.ABD_RING_PBO,
                        ROLE.ABD_RING_VIEW,
                        ROLE.ABD_RING_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdBbSubmissionListKmzEvidence keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "abd-bb-document",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_RING_APPROVER,
                        ROLE.ABD_RING_VERIFICATOR,
                        ROLE.ABD_RING_PBO,
                        ROLE.ABD_RING_VIEW,
                        ROLE.ABD_RING_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdBbSubmissionListAbdBbDocument keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "atp",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_RING_APPROVER,
                        ROLE.ABD_RING_VERIFICATOR,
                        ROLE.ABD_RING_PBO,
                        ROLE.ABD_RING_VIEW,
                        ROLE.ABD_RING_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdBbSubmissionListAtp keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "abd-bb-handover-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_RING_APPROVER,
                    ROLE.ABD_RING_VERIFICATOR,
                    ROLE.ABD_RING_PBO,
                    ROLE.ABD_RING_MAINTENANCE,
                    ROLE.ABD_RING_VIEW,
                    ROLE.ABD_RING_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdBbHandoverList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_RING_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_RING_APPROVER,
                    ROLE.ABD_RING_VERIFICATOR,
                    ROLE.ABD_RING_PBO,
                    ROLE.ABD_RING_MAINTENANCE,
                    ROLE.ABD_RING_VIEW,
                    ROLE.ABD_RING_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdBbHandoverDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-fo-olt-handover-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_FOOLT_APPROVER,
                    ROLE.ABD_FOOLT_VERIFICATOR,
                    ROLE.ABD_FOOLT_PBO,
                    ROLE.ABD_FOOLT_MAINTENANCE,
                    ROLE.ABD_FOOLT_VIEW,
                    ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdFoOltHandoverList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_FOOLT_APPROVER,
                    ROLE.ABD_FOOLT_VERIFICATOR,
                    ROLE.ABD_FOOLT_PBO,
                    ROLE.ABD_FOOLT_MAINTENANCE,
                    ROLE.ABD_FOOLT_VIEW,
                    ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdFoOltHandoverDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-fo-olt-dashboard",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_FOOLT_APPROVER,
                    ROLE.ABD_FOOLT_VERIFICATOR,
                    ROLE.ABD_FOOLT_PBO,
                    ROLE.ABD_FOOLT_MAINTENANCE,
                    ROLE.ABD_FOOLT_VIEW,
                    ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdFoOltDashboard keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-fo-olt-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_FOOLT_APPROVER,
                    ROLE.ABD_FOOLT_VERIFICATOR,
                    ROLE.ABD_FOOLT_PBO,
                    ROLE.ABD_FOOLT_VIEW,
                    ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdFoOltList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-feeder-dashboard",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FEEDER_VIEW,
                    ROLE.ABD_FEEDER_VERIFICATOR_LM,
                    ROLE.ABD_FEEDER_VERIFICATOR,
                    ROLE.ABD_FEEDER_APPROVER,
                    ROLE.ABD_FEEDER_PBO,
                    ROLE.ABD_FEEDER_MAINTENANCE,
                  ]}
                >
                  <AbdFeederDashboard keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-feeder-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FEEDER_VIEW,
                    ROLE.ABD_FEEDER_VERIFICATOR_LM,
                    ROLE.ABD_FEEDER_VERIFICATOR,
                    ROLE.ABD_FEEDER_APPROVER,
                    ROLE.ABD_FEEDER_PBO,
                  ]}
                >
                  <AbdFeederList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-feeder-submission-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FEEDER_VIEW,
                    ROLE.ABD_FEEDER_VERIFICATOR_LM,
                    ROLE.ABD_FEEDER_VERIFICATOR,
                    ROLE.ABD_FEEDER_APPROVER,
                    ROLE.ABD_FEEDER_PBO,
                  ]}
                >
                  <AbdFeederSubmissionList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: "create",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FEEDER_VIEW,
                    ROLE.ABD_FEEDER_VERIFICATOR_LM,
                    ROLE.ABD_FEEDER_VERIFICATOR,
                    ROLE.ABD_FEEDER_APPROVER,
                    ROLE.ABD_FEEDER_PBO,
                  ]}
                >
                  <AbdFeederSubmissionCreate keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FEEDER_VIEW,
                        ROLE.ABD_FEEDER_VERIFICATOR_LM,
                        ROLE.ABD_FEEDER_VERIFICATOR,
                        ROLE.ABD_FEEDER_APPROVER,
                        ROLE.ABD_FEEDER_PBO,
                      ]}
                    >
                      <AbdFeederSubmissionListDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "bbtar",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FEEDER_VIEW,
                        ROLE.ABD_FEEDER_VERIFICATOR_LM,
                        ROLE.ABD_FEEDER_VERIFICATOR,
                        ROLE.ABD_FEEDER_APPROVER,
                        ROLE.ABD_FEEDER_PBO,
                      ]}
                    >
                      <AbdFeederSubmissionListDetailBbtar keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "kmz-evidence",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FEEDER_VIEW,
                        ROLE.ABD_FEEDER_VERIFICATOR_LM,
                        ROLE.ABD_FEEDER_VERIFICATOR,
                        ROLE.ABD_FEEDER_APPROVER,
                        ROLE.ABD_FEEDER_PBO,
                      ]}
                    >
                      <AbdFeederSubmissionListDetailKmzEvidence
                        keycloak={keycloak}
                      />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "abd-feeder-information",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FEEDER_VIEW,
                        ROLE.ABD_FEEDER_VERIFICATOR_LM,
                        ROLE.ABD_FEEDER_VERIFICATOR,
                        ROLE.ABD_FEEDER_APPROVER,
                        ROLE.ABD_FEEDER_PBO,
                      ]}
                    >
                      <AbdFeederSubmissionListDetailInformation
                        keycloak={keycloak}
                      />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
      {
        path: "abd-feeder-handover-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.ABD_FEEDER_VERIFICATOR_LM,
                    ROLE.ABD_FEEDER_VERIFICATOR,
                    ROLE.ABD_FEEDER_APPROVER,
                    ROLE.ABD_FEEDER_MAINTENANCE,
                    ROLE.ABD_FEEDER_PBO,
                    ROLE.ABD_FEEDER_VIEW,
                  ]}
                >
                  <AbdFeederHandoverList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.ABD_FEEDER_VERIFICATOR_LM,
                    ROLE.ABD_FEEDER_VERIFICATOR,
                    ROLE.ABD_FEEDER_APPROVER,
                    ROLE.ABD_FEEDER_MAINTENANCE,
                    ROLE.ABD_FEEDER_PBO,
                    ROLE.ABD_FEEDER_VIEW,
                  ]}
                >
                  <AbdFeederHandoverDetail keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
        ],
      },
      {
        path: "abd-fo-olt-submission-list",
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate
                  roles={[
                    ROLE.VENDOR,
                    ROLE.VENDOR_VIEW,
                    ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                    ROLE.ABD_FOOLT_APPROVER,
                    ROLE.ABD_FOOLT_VERIFICATOR,
                    ROLE.ABD_FOOLT_PBO,
                    ROLE.ABD_FOOLT_VIEW,
                    ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                  ]}
                >
                  <AbdFoOltSubmissionList keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: "create",
            element: (
              <Suspense fallback={<Loading />}>
                <RoleGate roles={[ROLE.VENDOR, ROLE.VENDOR_VIEW]}>
                  <AbdFoOltSubmissionListCreate keycloak={keycloak} />
                </RoleGate>
              </Suspense>
            ),
          },
          {
            path: ":id",
            children: [
              {
                index: true,
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_FOOLT_APPROVER,
                        ROLE.ABD_FOOLT_VERIFICATOR,
                        ROLE.ABD_FOOLT_PBO,
                        ROLE.ABD_FOOLT_VIEW,
                        ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdFoOltSubmissionListDetail keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "kmz-abd",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_FOOLT_APPROVER,
                        ROLE.ABD_FOOLT_VERIFICATOR,
                        ROLE.ABD_FOOLT_PBO,
                        ROLE.ABD_FOOLT_VIEW,
                        ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdFoOltSubmissionListKmzAbd keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "kmz-evidence",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_FOOLT_APPROVER,
                        ROLE.ABD_FOOLT_VERIFICATOR,
                        ROLE.ABD_FOOLT_PBO,
                        ROLE.ABD_FOOLT_VIEW,
                        ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdFoOltSubmissionListKmzEvidence keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "abd-fo-olt-document",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_FOOLT_APPROVER,
                        ROLE.ABD_FOOLT_VERIFICATOR,
                        ROLE.ABD_FOOLT_PBO,
                        ROLE.ABD_FOOLT_VIEW,
                        ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdFoOltSubmissionListAbdFoOltDocument
                        keycloak={keycloak}
                      />
                    </RoleGate>
                  </Suspense>
                ),
              },
              {
                path: "atp",
                element: (
                  <Suspense fallback={<Loading />}>
                    <RoleGate
                      roles={[
                        ROLE.VENDOR,
                        ROLE.VENDOR_VIEW,
                        ROLE.ABD_FOOLT_REGIONAL_CONSTRUCTION,
                        ROLE.ABD_FOOLT_APPROVER,
                        ROLE.ABD_FOOLT_VERIFICATOR,
                        ROLE.ABD_FOOLT_PBO,
                        ROLE.ABD_FOOLT_VIEW,
                        ROLE.ABD_FOOLT_HQ_CONSTRUCTION,
                      ]}
                    >
                      <AbdFoOltSubmissionListAtp keycloak={keycloak} />
                    </RoleGate>
                  </Suspense>
                ),
              },
            ],
          },
        ],
      },
    ],
  },
];
